

















import { createComponent } from '@vue/composition-api'

export default createComponent({
  name: 'AppNavbar',
  props: {
    dark: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    back: {
      type: Function
    },
    hide: {
      type: Boolean,
      default: false
    }
  },
  setup (_, { emit }) {
    return {
      onBackClick () {
        emit('back')
      },
      onMenuClick () {
        emit('menu')
      }
    }
  }
})
